<template>
    <div v-wechat-title="title" class="padding10" :style="{ 'min-height': `${this.screenHeight - 80}px` }">
        <div v-if="this.surgeryInfo && surgeryInfo.id">
            <el-row>
                <el-col :span="24" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px"
                        >病人信息：{{ this.surgeryInfo.patient_name || '--' }}/{{ this.surgeryInfo.age || '--' }}/{{ this.surgeryInfo.sex || '未知' }}</label
                    ></el-col
                >
            </el-row>
            <el-row>
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">手术间：{{ this.surgeryInfo.dic_operating_room || '--' }}</label></el-col
                >
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">住院号/床号：{{ this.surgeryInfo.visit_no || '--' }}/{{ this.surgeryInfo.bed_no || '--' }}</label>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">手术名称：{{ this.surgeryInfo.surgeries || '--' }}</label></el-col
                >
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">麻醉方式：{{ this.surgeryInfo.anaes_methods || '--' }}</label>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">麻醉医生：{{ this.surgeryInfo.anaes_surgeon || '--' }}</label></el-col
                >
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">手术医生：{{ this.surgeryInfo.surgeon || '--' }}</label>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">洗手护士：{{ this.surgeryInfo.equipment_nurse || '--' }}</label></el-col
                >
                <el-col :span="12" class="align-left">
                    <label style="line-height: 35px; padding-left: 20px">巡回护士：{{ this.surgeryInfo.circuit_nurse || '--' }}</label>
                </el-col>
            </el-row>
            <el-row> </el-row>
            <el-row>
                <el-col :span="24" class="align-center" style="color: red">
                    <h2 v-html="message"></h2>
                </el-col>
            </el-row>
        </div>
        <div style="position: fixed; bottom: 20px; right: 20px">
            <el-button type="primary" @click="confirm"> 确定 </el-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `MessageSocketBox`,
    prop: {

    },
    data() {
        return {
            title: `通知`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            messageHeaderId: this.$route.query.messageheaderId,
            surgeryInfo: {},
            messageHeader: {},
            msg: `closeWindow`
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.init()
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        message() {
            let content = `【紧急通知】${this.messageHeader.title}` + `</br>` + this.messageHeader.content
            return content
        }
    },
    mounted() {

    },
    methods: {
        init() {
            if (!this.messageHeaderId) return
            // 获取当前手术和消息信息
            if (this.surgeryId) {
                let req = this.myaxios.get(`/api/Operation/Home/Get?id=${this.surgeryId}`)
                req.then(data => {
                    this.surgeryInfo = data
                })
            }
            let req1 = this.myaxios.get(`/api/Operation/MessageHeader/Get?id=${this.messageHeaderId}`)
            req1.then(data1 => {
                this.messageHeader = data1
            })
        },
        confirm() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: ``,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }

    },
    watch: {

    }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/MessageSocketBox.vue